// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__16-cw","content":"styles_content__2J8Ky","checkbox":"styles_checkbox__1g3cv","checkboxLabel":"styles_checkboxLabel__26Qj1"};